import React from "react";

import { useNavigate, useTranslation } from "utils";

import { Button, Flex, Form, Link, Typography } from "components";

interface SignInButtonsProps {
  loading: boolean;
}

export const SignInButtons = ({ loading }: SignInButtonsProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation("signinup");

  return (
    <Flex vertical gap={32}>
      <Typography variant="paragraph-m">
        <Link dataTestId="forgot-password-link" to="/password" className="link green-text">
          {t("signin.buttons.password")}
        </Link>
      </Typography>
      <Flex vertical gap={16}>
        <Form.Item>
          <Button dataTestId="sign-in-button" type="primary" htmlType="submit" disabled={loading} loading={loading}>
            {t("signin.buttons.signin")}
          </Button>
        </Form.Item>
        <Button
          type="secondary"
          onClick={() => navigate("/sign-up")}
          dataTestId="sign-up-button"
          disabled={loading}
          mixpanelText={t("signin.buttons.createAccount")}
        >
          {t("signin.buttons.createAccount")}
        </Button>
      </Flex>
    </Flex>
  );
};
